// Ð¡ÐµÑÑÐ¹ Ð´Ð¸Ð»ÐµÑ Ð½Ðµ Ð²ÑÐ±Ð¸ÑÐ°ÐµÑ ÐÐ¦ Ð¸ Ð³Ð¾ÑÐ¾Ð´ Ð²ÑÑÑÐ½ÑÑ: ÐÐ¦ Ð±ÐµÑÑÑÑÑ ÐµÐ³Ð¾ ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÐ¹ (autoSellerDc), Ð³Ð¾ÑÐ¾Ð´ â Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ ÐÐ¦.
// ÐÑÐ±ÑÐ°Ð½Ð½Ð¾Ðµ Ð² ÑÐ¾ÑÐ¼Ðµ Ð²ÑÑÑÐ½ÑÑ (ÑÐµÐ»ÐµÐºÑ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½, ÐµÑÐ»Ð¸ Ð°Ð²ÑÐ¾Ð²ÑÐ±Ð¾Ñ Ð½Ðµ ÑÑÐ°Ð±Ð¾ÑÐ°Ð») Ð²Ð°Ð¶Ð½ÐµÐµ Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð»ÐµÐ½Ð½Ð¾Ð³Ð¾.
export const carDcPayload = (values, autoDc) => {
  const picked = [].concat(values?.dc || []).map((dc) => dc?.value);
  const dcIds = (autoDc ? [autoDc.value] : picked).filter((value) => value != null);
  return { dcIds, cityId: values?.cityId?.value ?? autoDc?.cityId ?? undefined };
};
